export type CursorInsertResult = {
  value: string;
  cursor: number;
};

// Insert `insertion` at `[selectionStart, selectionEnd)` in `source`,
// returning the new string and the new caret position (placed after the
// inserted text). Clamps out-of-range positions so callers don't need to
// validate selection state themselves.
export function insertAtCursor(
  source: string,
  insertion: string,
  selectionStart: number,
  selectionEnd: number,
): CursorInsertResult {
  const start = Math.max(0, Math.min(selectionStart, source.length));
  const end = Math.max(start, Math.min(selectionEnd, source.length));
  const value = source.slice(0, start) + insertion + source.slice(end);
  return { value, cursor: start + insertion.length };
}
